import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Topic } from '../topic'
import { SearchTerm } from '../search-term'
import { TopicService } from '../topic.service'
import { Observable }  from 'rxjs/Observable';
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { AdminService } from '../admin.service'

@Component({
  selector: 'app-topic-box',
  templateUrl: './topic-box.component.html',
  styleUrls: ['./topic-box.component.css']
})
export class TopicBoxComponent implements OnInit {
  @Input() topic: Topic
  @Input() isEdit = false
  @Input() isShortDisplay = false
  @Input() isLongDisplay = false

  private topicTitle = ''
  private submitTopicClicked = false
  private isDelete = false

  constructor(
    private router: Router,
    public rts: RuntimeService,
    private topics: TopicService,
    private ads: AdminService
  ) { }

  ngOnInit() {
    if (!this.topic && this.topics.currentTopic)
      this.topic = this.topics.currentTopic

    if (!this.topic && this.rts.currentProject) {
      this.topic = this.topics.newTopic()
    }

    this.topicTitle = this.topic.title
  }

  ngOnDestroy() {
    if (this.topic && this.topic.isNew)
      this.rts.currentProject.topicsMap.delete(this.topic.id)
    this.topics.currentTopic = null
  }


  keyUp(event) {
    console.log(123, event)
  }

  switchEdit(runClear?: boolean) {
    if (runClear) {
      this.ads.clearSwitches()
      this.isEdit = false
    }
    if (this.isEdit)
      this.ngOnDestroy()
    else
      this.topics.currentTopic = this.topic
    this.isEdit = !this.isEdit
    this.ads.newTopicOn = this.isEdit
  }

  get hasTopicTitleError() {
    if (!this.submitTopicClicked)
      return false
    return !this.topicTitle.length
  }

  switchDelete() {
    this.isDelete = !this.isDelete
  }

  confirmDelete() {
    let obs: Observable<any> = this.topics.delete(this.topic)
    obs.subscribe((x) => this.ads.newTopicOn = false)
  }

  save() {
    this.submitTopicClicked = true
    if (this.hasTopicTitleError)
      return
    this.topic.title = this.topicTitle
    let obs: Observable<any> = this.topics.save(this.topic)
    obs.subscribe((x) => {
      this.switchEdit()
    })
  }

  searchTermSwitch(st: SearchTerm) {
    this.rts.currentProject.bindTopicSearchTerm(this.topic, st)
  }

  isBound(st: SearchTerm) {
    return this.rts.currentProject.isBound(this.topic, st)
  }

  get searchTerms() {
    return this.rts.currentProject.topicSearchTerms(this.topic)
  }

}



// WEBPACK FOOTER //
// ./src/app/topic-box/topic-box.component.ts